<!-- Main Container -->
<div class="absolute inset-0 flex flex-col min-w-0 overflow-hidden">
  <!-- Header Section -->
  <div
    class="flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between p-6 pb-22 bg-default dark:bg-transparent top-header"
  >
    <div class="flex-1 min-w-0">
      <!-- Back Button -->
      <div class="flex">
        <a
          class="inline-flex items-center -ml-1.5 text-secondary font-medium hover:cursor-pointer hover:text-primary transition-colors"
          (click)="goBack()"
        >
          <mat-icon
            class="icon-size-5 text-secondary"
            [svgIcon]="'heroicons_solid:chevron-left'"
          ></mat-icon>
          <span class="ml-1">Back</span>
        </a>
      </div>

      <!-- Page Title -->
      <div class="mt-2">
        <h2
          class="text-3xl md:text-4xl font-extrabold tracking-tight leading-7 sm:leading-10 text-gray-900 dark:text-white"
        >
          Payment Receipts
        </h2>
      </div>
    </div>
  </div>

  <!-- Content Area -->
  <div
    class="flex-auto p-6 sm:p-10 rounded-t-2xl shadow overflow-y-auto bg-card dark:bg-gray-800"
    cdkScrollable
  >
    <!-- With Invoices -->
    <div *ngIf="invoicesToDisplay.length > 0">
      <div class="mb-6">
        <h3 class="text-xl font-semibold text-gray-900 dark:text-white">
          Your Payment History
        </h3>
        <p class="text-secondary dark:text-gray-400">
          View and manage your invoices and receipts
        </p>
      </div>

      <!-- Receipts Grid -->
      <div class="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        <!-- Receipt Card -->
        <div
          *ngFor="let invoice of invoicesToDisplay"
          class="bg-white dark:bg-gray-700 rounded-xl shadow-md overflow-hidden border border-gray-100 dark:border-gray-600 transition-all hover:shadow-lg"
        >
          <!-- Receipt Header -->
          <div
            class="p-4 border-b border-gray-100 dark:border-gray-600 flex justify-between items-start"
          >
            <div class="min-w-0">
              <h4
                class="text-lg font-semibold truncate text-gray-900 dark:text-white"
              >
                {{ invoice.Name }}
              </h4>
              <span
                class="inline-block mt-1 px-2 py-1 rounded-full text-xs font-medium"
                [ngClass]="{
                  'bg-green-100 text-green-800': invoice.Invoice_Paid__c,
                  'bg-yellow-100 text-yellow-800': !invoice.Invoice_Paid__c
                }"
              >
                {{ invoice.Invoice_Paid__c ? "Paid" : "Pending" }}
              </span>
            </div>
            <div class="text-xl font-bold text-gray-900 dark:text-white">
              {{ invoice.Program_Fee__c | currency : "CAD" }}
            </div>
          </div>

          <!-- Receipt Details -->
          <div class="p-4 space-y-3">
            <div class="flex">
              <span
                class="text-sm font-medium text-gray-500 dark:text-gray-400 w-24"
                >Type:</span
              >
              <span class="text-sm text-gray-900 dark:text-white truncate">
                {{ invoice.Invoice_Title__c.split("-")[0].trim() }}
              </span>
            </div>
            <div class="flex">
              <span
                class="text-sm font-medium text-gray-500 dark:text-gray-400 w-24"
                >Program:</span
              >
              <span class="text-sm text-gray-900 dark:text-white">
                {{ invoice.programName }}
              </span>
            </div>
            <div class="flex">
              <span
                class="text-sm font-medium text-gray-500 dark:text-gray-400 w-24"
                >Schedule:</span
              >
              <span class="text-sm text-gray-900 dark:text-white">
                {{ invoice.classScheduleName }}
              </span>
            </div>
          </div>

          <!-- Receipt Actions -->
          <div
            class="p-4 border-t border-gray-100 dark:border-gray-600 flex flex-wrap gap-2"
          >
            <button
              mat-stroked-button
              (click)="openInvoiceModal(invoice)"
              class="flex items-center"
            >
              <mat-icon
                class="icon-size-5 mr-1"
                [svgIcon]="'heroicons_solid:eye'"
              ></mat-icon>
              View Details
            </button>

            <!-- Pay Now Button (for unpaid invoices) -->
            <ng-container *ngIf="!invoice.Invoice_Paid__c">
              <button
                mat-flat-button
                color="primary"
                (click)="togglePaymentForm(invoice)"
                [disabled]="paymentNowLoading || paymentProcessing"
                class="flex items-center"
              >
                <span *ngIf="!paymentNowLoading">Pay Now</span>
                <span *ngIf="paymentNowLoading">Preparing Payment...</span>
                <mat-icon
                  *ngIf="!paymentNowLoading"
                  class="ml-1 icon-size-5"
                  [svgIcon]="'heroicons_solid:arrow-narrow-right'"
                ></mat-icon>
                <mat-spinner
                  *ngIf="paymentNowLoading"
                  diameter="20"
                  class="ml-2"
                ></mat-spinner>
              </button>

              <!-- Payment Options (shown after clicking Pay Now) -->
              <div
                *ngIf="
                  selectedInvoiceId === invoice.Id && !selectedPaymentGateway
                "
                class="mt-4 w-full p-4 rounded-lg bg-gray-50 dark:bg-gray-600 border border-gray-200 dark:border-gray-500 space-y-4"
              >
                <div class="flex items-center justify-between">
                  <h5
                    class="text-lg font-semibold text-gray-800 dark:text-white"
                  >
                    Select Payment Method
                  </h5>
                  <button
                    type="button"
                    class="text-sm text-red-500 hover:underline"
                    (click)="selectedInvoiceId = null"
                  >
                    Cancel
                  </button>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
  <!-- Authorize.net Option -->
  <!-- <button
  (click)="selectedPaymentGateway = 'authorize'; setupAuthorizeNetForm()"
  class="p-4 border rounded-lg hover:border-primary-500 dark:hover:border-primary-400 transition-colors flex flex-col items-center justify-center h-full"
>
    <div class="flex items-center justify-center h-16">
      <img
        src="assets/TrailFusion/Miscellaneous/authorize-net.png"
        alt="Authorize.net"
        class="h-full w-auto object-contain"
      />
    </div>
  </button> -->
<button
  (click)="selectedPaymentGateway = 'authorize'; setupAuthorizeNetForm()"
  class="p-4 border rounded-lg hover:border-primary-500 dark:hover:border-primary-400 transition-colors flex flex-col items-center justify-center h-full"
  disabled="true"
  style="opacity: 0.6; cursor: not-allowed;"
  title="Authorize.net payments are currently unavailable"
>
  <div class="flex items-center justify-center h-16">
    <img
      src="assets/TrailFusion/Miscellaneous/authorize-net.png"
      alt="Authorize.net"
      class="h-full w-auto object-contain"
    />
  </div>
</button>
  <!-- Stripe Option -->
  <button
    (click)="selectedPaymentGateway = 'stripe'"
    class="p-4 border rounded-lg hover:border-primary-500 dark:hover:border-primary-400 transition-colors flex flex-col items-center justify-center h-full"
  >
    <div class="flex items-center justify-center h-16">
      <img
        src="assets/TrailFusion/Miscellaneous/stripe-logo.png"
        alt="Stripe"
        class="h-full w-auto object-contain"
      />
    </div>
  </button>
</div>
              </div>

              <!-- Payment Form (shown after selecting a gateway) -->
              <div
                *ngIf="
                  selectedInvoiceId === invoice.Id && selectedPaymentGateway
                "
                class="mt-4 w-full p-4 rounded-lg bg-gray-50 dark:bg-gray-600 border border-gray-200 dark:border-gray-500 space-y-4"
              >
                <div class="flex items-center justify-between">
                  <h5
                    class="text-lg font-semibold text-gray-800 dark:text-white"
                  >
                    Enter Payment Details ({{
                      selectedPaymentGateway === "authorize"
                        ? "Authorize.net"
                        : "Stripe"
                    }})
                  </h5>
                  <button
                    type="button"
                    class="text-sm text-red-500 hover:underline"
                    (click)="selectedPaymentGateway = null"
                  >
                    Back
                  </button>
                </div>
              <app-authorized-payment
                *ngIf="selectedInvoiceId === invoice.Id && selectedPaymentGateway === 'authorize'"
                [invoice]="invoice"
                [parentId]="_fetchData.parentId"
                [parentEmail]="parentEmail"
                (paymentSuccess)="handlePostPaymentUpdate(invoice)"
                (paymentFailure)="showSnackbar($event, 'error')"
              ></app-authorized-payment>
              <app-stripe-payment
                *ngIf="selectedInvoiceId === invoice.Id && selectedPaymentGateway === 'stripe'"
                [invoice]="invoice"
                [parentId]="_fetchData.parentId"
                [parentEmail]="parentEmail"
                (paymentSuccess)="handlePostPaymentUpdate(invoice)"
                (paymentFailure)="showSnackbar($event, 'error')"
              ></app-stripe-payment>
              </div>
              <div *ngIf="processingPayment" class="payment-processing-overlay">
                <div class="payment-processing-container">
                  <mat-spinner diameter="50"></mat-spinner>
                  <p class="processing-message">{{ processingMessage }}</p>
                </div>
              </div>
              <div class="loaderMain" *ngIf="pageLoader === true">
                <div>
                  <img
                    src="assets\TrailFusion\Trail-Fusion-logo.jpg"
                    class="LoaderImage"
                  />
                  <p class="loaderText">{{ pageLoaderText }}</p>
                </div>
              </div>
            </ng-container>

            <!-- Download Button (for paid invoices) -->
            <ng-container *ngIf="invoice.Invoice_Paid__c">
              <button
                mat-stroked-button
                (click)="generateReceiptPDF(invoice)"
                class="flex items-center"
              >
                <mat-icon
                  class="icon-size-5 mr-1"
                  [svgIcon]="'heroicons_solid:download'"
                ></mat-icon>
                Download
              </button>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div
      *ngIf="invoicesToDisplay.length === 0"
      class="flex flex-col items-center justify-center py-12 text-center"
    >
      <mat-icon
        class="text-gray-400 dark:text-gray-500 icon-size-16 mb-4"
        [svgIcon]="'heroicons_solid:receipt-tax'"
      ></mat-icon>
      <h4 class="text-xl font-semibold text-gray-700 dark:text-gray-300 mb-2">
        No Payment Receipts Found
      </h4>
      <p class="text-gray-500 dark:text-gray-400 max-w-md mb-6">
        You don't have any payment receipts yet. Your receipts will appear here
        after you make a payment.
      </p>
      <button mat-flat-button color="primary" (click)="goBack()">
        Back to Registered Programs
      </button>
    </div>
  </div>
</div>

<!-- Invoice Details Modal -->
<div
  class="fixed inset-0 bg-black bg-opacity-50 z-50 transition-opacity"
  *ngIf="showInvoiceModal"
  (click)="closeInvoiceModal()"
></div>

<div
  class="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white dark:bg-gray-800 rounded-xl shadow-xl z-50 w-full max-w-2xl max-h-[90vh] overflow-y-auto"
  *ngIf="showInvoiceModal"
>
  <div
    class="sticky top-0 bg-white dark:bg-gray-800 p-4 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center"
  >
    <h2 class="text-xl font-bold text-gray-900 dark:text-white">
      Invoice Details
    </h2>
    <button
      mat-icon-button
      (click)="closeInvoiceModal()"
      class="text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="p-6 space-y-6">
    <!-- Invoice Info -->
    <div class="space-y-3">
      <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-2">
        Invoice Information
      </h3>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <p class="text-sm text-gray-500 dark:text-gray-400">Invoice Number</p>
          <p class="text-gray-900 dark:text-white">
            {{ selectedInvoice.Name }}
          </p>
        </div>
        <div>
          <p class="text-sm text-gray-500 dark:text-gray-400">Total Amount</p>
          <p class="text-gray-900 dark:text-white">
            {{ selectedInvoice.Program_Fee__c | currency : "CAD" }}
          </p>
        </div>
        <div>
          <p class="text-sm text-gray-500 dark:text-gray-400">Child</p>
          <p class="text-gray-900 dark:text-white">
            {{ selectedInvoice.childName }}
          </p>
        </div>
        <div>
          <p class="text-sm text-gray-500 dark:text-gray-400">Parent</p>
          <p class="text-gray-900 dark:text-white">{{ parentName }}</p>
        </div>
        <div>
          <p class="text-sm text-gray-500 dark:text-gray-400">Status</p>
          <p class="text-gray-900 dark:text-white">
            {{ selectedInvoice.Invoice_Paid__c ? "Paid" : "Pending Payment" }}
          </p>
        </div>
        <div>
          <p class="text-sm text-gray-500 dark:text-gray-400">Payment Type</p>
          <p class="text-gray-900 dark:text-white">
            {{ selectedInvoice.Invoice_Title__c }}
          </p>
        </div>
      </div>
    </div>

    <!-- Program Details -->
    <div class="space-y-3">
      <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
        Program Information
      </h3>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <p class="text-sm text-gray-500 dark:text-gray-400">Program Name</p>
          <p class="text-gray-900 dark:text-white">
            {{ selectedInvoice.programName }}
          </p>
        </div>
        <div *ngIf="selectedInvoice.paymentType !== 'Full Payment'">
          <p class="text-sm text-gray-500 dark:text-gray-400">Class Schedule</p>
          <p class="text-gray-900 dark:text-white">
            {{ selectedInvoice.classScheduleName }}
          </p>
        </div>
      </div>
    </div>

    <!-- Schedules Section -->
    <div
      class="space-y-3"
      *ngIf="
        selectedInvoice.Notes__c &&
        selectedInvoice.paymentType !== 'Full Payment'
      "
    >
      <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
        Schedules
      </h3>
      <div
        class="prose prose-sm dark:prose-invert max-w-none"
        [innerHTML]="formatNotesForDisplay(selectedInvoice.Notes__c)"
      ></div>
    </div>
  </div>

  <!-- Modal Actions -->
  <div
    class="sticky bottom-0 bg-white dark:bg-gray-800 p-4 border-t border-gray-200 dark:border-gray-700 flex justify-end"
  >
    <button mat-stroked-button (click)="closeInvoiceModal()">Close</button>
  </div>
</div>
